import React, { useEffect, useMemo } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import styles from './styles/styles.module.scss';
import Feed from '../Feed';
import { getFeedOptions, getActiveFeed } from '../../ducks/feeds';
import { openConnectModal } from '../../ducks/connectFlow';
import CommunityConnect from '../../../../components/svg/shared/CommunityConnect';

const FeedPane = () => {
  const dispatch = useDispatch();
  const { activeFeedKey, feeds } = useSelector(state => state.feeds, shallowEqual);

  useEffect(() => {
    dispatch(getFeedOptions());
  }, []);

  useEffect(() => {
    if (!activeFeedKey) {
      return;
    }

    dispatch(getActiveFeed());
  }, [activeFeedKey]);

  const activeFeed = useMemo(() => {
    if (!activeFeedKey) {
      return null;
    }

    return feeds.find(feed => feed.key === activeFeedKey);
  }, [activeFeedKey, feeds]);

  const dispatchCommunityModal = () => {
    dispatch(openConnectModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleAndFilter}>
        <h2 className={styles.header}>Community</h2>
        <div>{activeFeedKey}</div>
        <button className={styles.communityTrigger} onClick={dispatchCommunityModal}>
          <CommunityConnect />
        </button>
      </div>
      {activeFeed && (
        <div className={styles.feedContainer}>
          <Feed feed={activeFeed} />
        </div>
      )}
    </div>
  );
};

export default FeedPane;
